import { render } from "./ActionMenu.vue?vue&type=template&id=f7525526&scoped=true"
import script from "./ActionMenu.vue?vue&type=script&lang=js"
export * from "./ActionMenu.vue?vue&type=script&lang=js"

import "./ActionMenu.vue?vue&type=style&index=0&id=f7525526&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7525526"]])

export default __exports__